export const getNAField = (key: string, type: string) => {
  const keySuffixSeparator = key && type ? '-' : ''
  const suffix = type ? `${type}` : ''

  return `${key || ''}${keySuffixSeparator}${suffix}`.replace(/\s/g, '').toLowerCase()
}
